const removePermissions = (permissions, idsToRemove) => {
    return permissions.filter((p) => !idsToRemove.includes(p));
};

const addPermissions = (permissions, idsToAdd) => {
    return [...permissions, ...idsToAdd];
};

export const handleCheckboxChange = (
    menus,
    setSelectedPermissions,
    values,
    isParent,
    type
) => {
    // 判断当前点击的是什么类型的节点
    let currentType = type;
    let parentMenuId = isParent;
    let parentMenuItemId = null;

    // 如果type不是字符串，根据数据结构自动判断类型
    // console.log('type类型检查:', typeof type, 'type值:', type);
    if (typeof type !== "string") {
        // 检查是否是菜单（一级）
        const isMenu = menus.some((menu) => menu.id === values);
        if (isMenu) {
            currentType = "1";
            parentMenuId = null;
        } else {
            // 检查是否是菜单项（二级）
            let isMenuItem = false;
            for (const menu of menus) {
                const foundMenuItem = menu.menuItemList?.find(
                    (item) => item.id === values
                );
                if (foundMenuItem) {
                    isMenuItem = true;
                    parentMenuId = menu.id;
                    break;
                }
            }

            if (isMenuItem) {
                currentType = "2";
            } else {
                // 否则是权限（三级）
                currentType = "3";
                // 对于权限，isParent 参数就是菜单项ID
                parentMenuItemId = isParent;

                // 找到菜单项的父级菜单
                for (const menu of menus) {
                    const foundMenuItem = menu.menuItemList?.find(
                        (item) => item.id === parentMenuItemId
                    );
                    if (foundMenuItem) {
                        parentMenuId = menu.id;
                        //    console.log('找到权限父级关系 - 权限:', values, '菜单项:', parentMenuItemId, '菜单:', parentMenuId);
                        break;
                    }
                }
            }
        }
    } else {
        // type是字符串，直接使用
        currentType = type;


        if (currentType === "3") {
            // 对于权限，isParent 参数就是菜单项ID
            parentMenuItemId = isParent;
            // console.log('权限的父级菜单项ID:', parentMenuItemId);

            // 找到菜单项的父级菜单
            for (const menu of menus) {
                const foundMenuItem = menu.menuItemList?.find(
                    (item) => item.id === parentMenuItemId
                );
                if (foundMenuItem) {
                    parentMenuId = menu.id;
                    // console.log('找到菜单项的父级菜单ID:', parentMenuId);
                    break;
                }
            }
        } else if (currentType === "2") {
            // 对于菜单项，isParent 参数就是菜单ID
            parentMenuId = isParent;
            // console.log('菜单项的父级菜单ID:', parentMenuId);
        }
    }

    //获取当前菜单项的父级菜单
    const parentMenu = menus.find((item) => item.id === parentMenuId);

    //选中的数据
    setSelectedPermissions((prevSelectedPermissions) => {
        let updatedPermissions = [...prevSelectedPermissions];

        //清除选中的数据
        const removeFromPermissions = (ids) => {
            ids.forEach((id) => {
                updatedPermissions = removePermissions(updatedPermissions, [id]);
            });
        };

        //增加选中的数据
        const addToPermissions = (ids) => {
            ids.forEach((id) => {
                if (!updatedPermissions.includes(id)) {
                    updatedPermissions = addPermissions(updatedPermissions, [id]);
                }
            });
        };

        const isCurrentlySelected = updatedPermissions.includes(values);

        if (isCurrentlySelected) {
            // 取消选中逻辑
            removeFromPermissions([values]);

            if (currentType === "1") {
                // 取消选中菜单 - 取消所有子级
                const menu = menus.find((m) => m.id === values);
                if (menu) {
                    menu.menuItemList?.forEach((menuItem) => {
                        removeFromPermissions([menuItem.id]);
                        menuItem.permissionList?.forEach((permission) => {
                            removeFromPermissions([permission.id]);
                        });
                    });
                }
            } else if (currentType === "2") {
                // 取消选中菜单项 - 取消该菜单项下所有权限
                const menuItem = parentMenu?.menuItemList?.find(
                    (item) => item.id === values
                );
                if (menuItem) {
                    menuItem.permissionList?.forEach((permission) => {
                        removeFromPermissions([permission.id]);
                    });
                }

                // 检查父菜单是否还有其他选中的菜单项或权限，如果没有则取消父菜单
                const hasOtherSelectedItems = parentMenu?.menuItemList?.some((item) => {
                    if (item.id !== values && updatedPermissions.includes(item.id)) {
                        return true;
                    }
                    // 检查该菜单项下是否有选中的权限
                    return item.permissionList?.some((perm) =>
                        updatedPermissions.includes(perm.id)
                    );
                });
                if (!hasOtherSelectedItems) {
                    removeFromPermissions([parentMenuId]);
                }
            } else if (currentType === "3") {
                // 取消选中权限 - 检查是否需要取消父级
                const menuItem = parentMenu?.menuItemList?.find(
                    (item) => item.id === parentMenuItemId
                );

                // 检查该菜单项下是否还有其他选中的权限
                const hasOtherSelectedPermissions = menuItem?.permissionList?.some(
                    (perm) => perm.id !== values && updatedPermissions.includes(perm.id)
                );

                if (!hasOtherSelectedPermissions) {
                    // 取消菜单项
                    removeFromPermissions([parentMenuItemId]);

                    // 检查父菜单是否还有其他选中的菜单项
                    const hasOtherSelectedMenuItems = parentMenu?.menuItemList?.some(
                        (item) => updatedPermissions.includes(item.id)
                    );

                    if (!hasOtherSelectedMenuItems) {
                        removeFromPermissions([parentMenuId]);
                    }
                }
            }
        } else {
            // 选中逻辑
            if (currentType === "1") {
                // 选中菜单 - 选中所有子级
                const menu = menus.find((m) => m.id === values);
                if (menu) {
                    addToPermissions([values]);
                    menu.menuItemList?.forEach((menuItem) => {
                        addToPermissions([menuItem.id]);
                        menuItem.permissionList?.forEach((permission) => {
                            addToPermissions([permission.id]);
                        });
                    });
                }
            } else if (currentType === "2") {
                // 选中菜单项 - 选中该菜单项下所有权限，并确保父菜单被选中
                addToPermissions([values, parentMenuId]);

                const menuItem = parentMenu?.menuItemList?.find(
                    (item) => item.id === values
                );
                menuItem?.permissionList?.forEach((permission) => {
                    addToPermissions([permission.id]);
                });
            } else if (currentType === "3") {
                // 选中权限 - 确保父级菜单项和菜单被选中
                // console.log('选中权限:', values, '父级菜单项:', parentMenuItemId, '爷爷级菜单:', parentMenuId);

                addToPermissions([values]);

                // 确保父级菜单项被选中
                if (parentMenuItemId) {
                    // console.log('添加父级菜单项:', parentMenuItemId);
                    addToPermissions([parentMenuItemId]);
                }

                // 确保爷爷级菜单被选中
                if (parentMenuId) {
                    // console.log('添加爷爷级菜单:', parentMenuId);
                    addToPermissions([parentMenuId]);
                }

                // console.log('权限选中后的状态:', updatedPermissions);
            }
        }

        return updatedPermissions;
    });
};
